import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import "@/assets/css/thalamus.css"


import axios from 'axios';

const app = createApp(App)
const vuetify = createVuetify({
  components,
  directives,
})

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

app.use(router)
app.use(vuetify)
app.mount('#app')